import React from 'react';
import contact from '../assets/Images/mainakibe@outlook.com.png';

const Contact = () => {
  return (
    <div className="contact-wrapper">
      <div className="text">
        <div className="title">
          <h2>Let's connect!</h2>
          <div className="line"></div>
        </div>
        <p>
          I am currently accepting new freelance clients and interesting project
          opportunities.
        </p>

        <div className="contact">
          <span>
            Email me at:{' '}
            <strong className="bolder">kibemaina22@outlook.com</strong>
          </span>
          <br />
          <small>Or</small>
          <br />
          <span>
            Call me at: <strong className="bolder">+254795547592</strong>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Contact;
